export default __webpack_public_path__ + "static/media/voucher.c1e83c1b.png";